const ExportTab = Object.freeze({
  REACTIONS: 0,
});

export default ExportTab;
